import { useEffect, useRef } from 'react';
import { sampleEcg, deriveRhythm } from './ecgGenerator';

export const EcgTrace = ({ rhythm, fc = 80, height = 90, color = '#22c55e' }) => {
  const canvasRef = useRef(null);
  const stateRef = useRef({ rhythm, fc });
  stateRef.current = { rhythm, fc };

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const W = canvas.width;
    const H = canvas.height;
    const SPEED = 90; // px por segundo
    let x = 0;
    let raf;
    let last = performance.now();
    ctx.fillStyle = '#0f172a';
    ctx.fillRect(0, 0, W, H);

    const draw = (now) => {
      const dt = Math.min(0.05, (now - last) / 1000);
      last = now;
      const { rhythm: r, fc: hr } = stateRef.current;
      const effRhythm = r || deriveRhythm(hr || 80);
      const px = Math.max(1, Math.round(SPEED * dt));
      for (let i = 0; i < px; i++) {
        x = (x + 1) % W;
        // borrar columna + gap
        ctx.fillStyle = '#0f172a';
        ctx.fillRect(x, 0, 8, H);
        const v = sampleEcg(effRhythm, hr || 80, now + (i / SPEED) * 1000);
        const y = H / 2 - (v / 60) * (H / 2 - 6);
        ctx.fillStyle = color;
        ctx.fillRect(x, Math.max(2, Math.min(H - 2, y)), 2, 2);
      }
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(raf);
  }, [color]);

  return (
    <canvas
      ref={canvasRef}
      width={420}
      height={height}
      className="w-full rounded-lg"
      style={{ background: '#0f172a' }}
      data-testid="supervision-ecg-trace"
    />
  );
};

export default EcgTrace;
